export const logError = (string, stack) => {
  console.error(string)
  if (stack) console.error(stack)
}
